import React from "react";
import { CodedProperty, ensure, NamedProperty, ResolutionProperty } from "sprint-common-web";

import { OrderAssetAvailability } from "../../types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../../types/OrderAssetStorageType";
import { VideoInfo } from "./VideoInfo";

export const renderVideoAvailability = <
    T extends {
        video: {
            availability: OrderAssetAvailability;
            nonMatchingVideos: {
                assetId: string;
                subtitle: CodedProperty;
                aspectRatio: NamedProperty;
                resolution: ResolutionProperty;
            }[];
            storageType?: OrderAssetStorageType;
        };
        encodeSpecification: { targetAspectRatio: NamedProperty };
        targetResolution?: ResolutionProperty;
    }
>(
    item?: T
): JSX.Element => {
    ensure(item);

    return (
        <VideoInfo
            availability={item.video.availability}
            requestedAspectRatio={item.encodeSpecification.targetAspectRatio}
            type={item.video.storageType ?? OrderAssetStorageType.Cloud}
            requestedResolution={item.targetResolution}
            nonMatchingVideos={item.video.nonMatchingVideos}
            testId={"order-cloud-video-availability-status"}
        />
    );
};
